import React, { useState, useEffect } from "react";
import { Box, Button, Select, MenuItem, Paper, 
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  TableContainer,
 } from "@mui/material";
import { useNavigate } from "react-router";
import {useDispatch, useSelector} from "react-redux"
import { setUserInfo } from "../../../redux/slice/user";
import api from "../../../API";
import { SearchBackDrop } from "../../component/common/SearchBackDrop";
import CustomPagination from "../../component/common/CustomPagination";
import { KmTransData } from "../isp/KhmISPDialog";
import KhmInstructionCreatePage from "./KhmInstructionCreatePage";

const initailSwTransData: any = {
  idx : -1,
  crw_idx : -1,
  topic_cd : "",
  data_type_cd : "",
  created_date : "",
  seq : "",
  mgm_pk : "",
  issue_date : "",
  writer_ko : "",
  writer_km : "",
  copyrighter_ko : "",
  copyrighter_km : "",
  org_ext : "",
  data_src : "",

  url: "",
  kwd_km: "",
  kwd_ko: "",
  kwd_en: "",
  title_km: "",
  title_ko: "",
  title_en: "",
  text_km: "",
  text_ko: "",
  text_en: "",

  wrd_cnt : "",
  file_size : "",
  
  prc_json : "",
  prc_yn : "",
  prc_date : "",
  
  isp1_user : "",
  isp1_yn : "",
  isp1_date : "",
  isp1_rsn : "",
  isp1_rsn_cd : "",
  
  isp2_user : "",
  isp2_yn : "",
  isp2_date : "",
  isp2_rsn : "",
  
  ins_date : "",
  instruction_yn: "",
  instruction_data: "",
  instruction_type: "",
};

export interface pageInfoType {
  current_page: number;
  total_pages: number;
}

const KhmInstructionListPage = (props:any) => {

  const dispatch = useDispatch();

  const nav = useNavigate();

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  let union_role = auth.user.roles.some((obj:any) => ['KHM_ISP'].includes(obj.role) && ['Y'].includes(obj.type));

  // const worker = auth.user.roles.filter((obj:any) => obj.role === 'KHM').map((info:any) => info.user_id)[0];   

  const [data, setData] = useState<any>(initailSwTransData);

  const [order, setOrder] = useState('desc');

  const [instruction_data, setInstruction_data] = useState('모두');

  const [topic_cd, setTopic_cd] = useState('모두');

  const [idx, setIdx] = useState('');

  const [p_idx, setP_idx] = useState('');

  const [instructionList, setInstructionList] = useState([]);

  // const [use_check_cnt, setUse_check_cnt] = useState<UseCheckCntType>(initailData_use_check);

  const [c_page, setC_page] = useState("")

  const [page, setPage] = useState(1);

  const [pagination, setPagination] = useState<pageInfoType | undefined>(
    undefined
  );
  
  const [total_cnt, setTotal_cnt] = useState(0);
  
  const [backdrop, setBackdrop] = useState<boolean>(false)

  const [worker, setWorker] = useState('모두');

  const [kmWorkers, setKmWorkers] = useState<any[]>([])

  const getAuth = async () => {
    if(!email){ nav('/') }
    api.get('/@me',{params:{email:email}})
    .then((resp:any) => {dispatch(setUserInfo(resp.data)); console.log('/@me',resp.data) })
      // alert("파일 업로드가 완료되었습니다.");
    .catch((error:any) => {console.error('에러',error.response);})
    // alert("파일 업로드 실패. " + error.response.data.error);
  }

  const goPage = (clickPage: any) => {
    setPage(clickPage);
  };

  const getKmIspWorkerList = async () => {
    setBackdrop(true)
    var result = await api.get("/gncWorkerList", {
      // params: {email:email,page:page,instruction_yn:instruction_yn}
      params: {email:email,role:'KHM_TRS'}
    });
    // console.log("result.data", result.data);
    let kmWorkList:any[] = []
    var datas = result.data.datas.map((worker:any) => {
      // // console.log(worker.name, worker.roles[0].user_id)
      kmWorkList.push({"name":worker.name,"user_id": worker.roles[0].user_id})
    })

    // console.log('kmWorkList',kmWorkList)
    setKmWorkers(kmWorkList)
    setBackdrop(false)
  }

  const kmInstructionList = async () => {
    
    setBackdrop(true)
    api.get('/km-instructionList',{params:{email:email,page:page,worker:worker,order:order,instruction_data:instruction_data,topic_cd:topic_cd,idx:idx}})
    .then((res:any) => {
      
      // console.log('리턴 데이터', res.data)
      if(res.data.datas.length > 0){
        // setInstructionList(res.data);
        // setData(res.data.datas[0]);
        setInstructionList(res.data.datas);

        if((data && data.idx == -1) || (pagination && page != pagination.current_page)){
          setData(res.data.datas[0])
        }

        setPagination(res.data.pagination)
        setTotal_cnt(res.data.pagination.total_count)
      }else{
        // console.log('api 리턴 데이터', res.data)
        setInstructionList(res.data.datas);
        setPagination(res.data.pagination)
        setTotal_cnt(0)
      }
      setBackdrop(false)
      // setPagination(res.data.pagination); 
      })
      // alert("파일 업로드가 완료되었습니다.");
    .catch((error:any) => {console.error('에러',error.response);setBackdrop(false);})
    // alert("파일 업로드 실패. " + error.response.data.error);
  }

  const updateAfter = () => {
    // setData(initailData);
    kmInstructionList();
  }

  useEffect(() => {
    getAuth()
    getKmIspWorkerList()
    kmInstructionList()
  },[page, order, instruction_data, topic_cd, idx, worker])

  return (
    <Box>
      {backdrop && ( <SearchBackDrop/> )}
      {/* 상단 메뉴 */}
      <Box display="flex" sx={{padding:"4px 8px 8px 8px"}}>
        <Box display="flex">
          <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px",alignSelf: "center"}}>작업할당 목록 (<b style={{color:"#1976d2"}}>{total_cnt != 0 ? total_cnt:0}</b> 건)</Box>
        </Box>
        <Box display="flex" sx={{alignItems: "center", justifyContent: "right"}}>

          {/* <Box sx={{marginLeft: "16px", fontSize:"16px"}}>작업상태</Box>
          <Select id="work_yn" value={work_yn} onChange={(e)=> { setWork_yn(e.target.value); kmInstructionList(e.target.value); goPage(1);}} sx={{width:"128px",height: "30px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
            <MenuItem dense value={"모두"}>모두</MenuItem>
            <MenuItem dense value={"0"}>미작업</MenuItem>
            <MenuItem dense value={"Y"}>적합</MenuItem>
            <MenuItem dense value={"N"}>부적합</MenuItem>
          </Select> */}
          
          <Box sx={{marginLeft:"8px", color:"#1976d2"}}>정렬</Box>
          <Select id="order" value={order} onChange={(e)=> setOrder(e.target.value)} sx={{width:"100px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
            <MenuItem dense value={"asc"}>처음</MenuItem>
            <MenuItem dense value={"desc"}>최신</MenuItem>
          </Select>

          <Box sx={{marginLeft:"24px", color:"#1976d2"}}>작성구분</Box>
          <Select id="order" value={instruction_data} onChange={(e)=> {setInstruction_data(e.target.value); setPage(1);}} sx={{width:"140px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
            <MenuItem dense value={"모두"}>모두</MenuItem>
            <MenuItem dense value={"None"}>미작성</MenuItem>
            <MenuItem dense value={"Y"}>작성</MenuItem>
          </Select>

          <Box sx={{marginLeft:"24px", color:"#1976d2"}}>주제분류</Box>
          <Select id="topic_cd" value={topic_cd || "모두"} onChange={(e)=> {setTopic_cd(e.target.value); setPage(1);}} sx={{width:"150px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
            <MenuItem dense value={"모두"}>모두</MenuItem>
            <MenuItem dense value={"101"}>문화,예술,교육</MenuItem>
            <MenuItem dense value={"102"}>역사,지리,관광</MenuItem>
            <MenuItem dense value={"103"}>스포츠,기타</MenuItem>
            <MenuItem dense value={"204"}>사회,산업</MenuItem>
            <MenuItem dense value={"205"}>정치,경제</MenuItem>
            <MenuItem dense value={"206"}>과학,의학</MenuItem>
            <MenuItem dense value={"307"}>관습,의례</MenuItem>
            <MenuItem dense value={"408"}>일상생활,음식</MenuItem>
          </Select>

          <Box sx={{marginLeft:"8px", color:"#1976d2"}}>워커</Box>
          <Select id="order" value={worker} onChange={(e)=>setWorker(e.target.value)} sx={{width:"200px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
            <MenuItem dense value={"모두"}>모두</MenuItem>
            {kmWorkers.length > 0 && kmWorkers.map((worker:any) => 
              <MenuItem key={worker} dense value={worker.user_id}>{worker.name}({worker.user_id})</MenuItem>
            )}
          </Select>

          <Box sx={{marginLeft:"24px", marginRight:"20px", fontWeight:700, letterSpacing:"-2px",alignSelf: "center"}}>idx</Box>
            <TextField sx={{fontSize:"8px"}} id="url" name="url" size="small"
                      value={p_idx} onChange={(e) => {setP_idx(e.target.value);}}
            // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
              InputProps={{
                style: {width: "100px", height:"30px", fontSize:"14px"},
                inputProps: { 
                  spellCheck: "false" // spellcheck를 false로 설정
                },
              }} 
            />
            <Button variant="contained" size="small" sx={{fontWeight:700, margin:"4px 8px", marginLeft:"auto", backgroundColor:"#2381fd"}}
                onClick={() => {
                  setIdx(p_idx); setPage(1);
                }}
              >
                적용
            </Button>

        </Box>
      </Box>
      {/* 상단 메뉴 */}

        <Box>
        {/* Task 단위 화면 */}
        <Box display="flex" justifyContent="center" >
          <Box sx={{padding:"4px 8px 8px 8px", width:"368px"}}>
            <Box display="flex">
              <Box><img style={{width:"24px", marginLeft:"8px", objectFit: "cover", alignSelf: "center"}} src={process.env.PUBLIC_URL + '/img/km_flag.jpg'} /></Box>
              <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "16px", letterSpacing:"-2px"}}>Khmer Data</Box>
            </Box>
            <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
            <TableContainer sx={{maxHeight:"680px",fontSize:"12px"}}>
              <Table size="small" aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>IDX</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>검수</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>작성</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>주제분류</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>형태</Box></TableCell>
                    {/* <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>CONCEPT</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>USE_CHECK</Box></TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                {(instructionList != undefined && instructionList.length > 0) ? instructionList.map((row:any, index:number) => (
                  <TableRow
                    key={index}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 }, cursor: 'pointer', ':hover': { backgroundColor: '#e1e1ee' } , backgroundColor:(data != undefined && row.idx === data.idx ? "#dbdbef": "#fff")}}
                    onClick={()=> {setData(row);}}
                  >
                    <TableCell component="th" scope="row" align="center">{row.idx}</TableCell>
                    <TableCell component="th" scope="row" align="center">
                      <Box sx={{width:"38px",fontSize:"12px", marginLeft:"8px", padding: "1px 3px 1px 3px", borderRadius:"4px",
                          border: (row.isp1_yn === "N" ? "2px solid red" : (row.isp1_yn === "0" ? "2px solid #bbb" : (row.isp1_yn === "Y" ? "2px solid #27cc2f" : "#000"))), color:"#000" }}>
                        {(row.isp1_yn === "Y" ? "적합" : (row.isp1_yn === "N" ? "부적합" : (row.isp1_yn === "0" ? "미작업":"-")))}
                      </Box>
                    </TableCell>
                    <TableCell component="th" scope="row" align="center">
                      <Box sx={{width:"38px",fontSize:"12px", marginLeft:"8px", padding: "1px 3px 1px 3px", borderRadius:"4px",
                          border: (row.instruction_data === "Y" ? "2px solid #27cc2f" : "2px solid #bbb"), color:"#000" }}>
                        {(row.instruction_data === "Y" ? "작성" : "미작성")}
                      </Box>
                    </TableCell>
                    <TableCell component="th" scope="row" align="center">
                      <Box sx={{width:"48px",fontSize:"12px", marginLeft:"8px", padding: "1px 3px 1px 3px", borderRadius:"4px", color:"#000" }}>
                      {
                        (row.topic_cd == "101" ?  "문화,예술,교육"
                        : (row.topic_cd == "102" ? "역사,지리,관광"
                          : (row.topic_cd == "103" ? "스포츠,기타"
                            : (row.topic_cd == "204" ? "사회,산업"
                              : (row.topic_cd == "205" ? "정치,경제"
                                : (row.topic_cd == "206" ? "과학,의학"
                                  : (row.topic_cd == "307" ? "관습,의례"
                                    : (row.topic_cd == "408" ? "일상생활,음식"
                                      : "-")))))))
                        )
                      }
                      </Box>
                    </TableCell>
                    <TableCell component="th" scope="row" align="center">
                      <Box sx={{width:"48px",fontSize:"12px", marginLeft:"8px", padding: "1px 3px 1px 3px", borderRadius:"4px", color:"#000" }}>
                        {row.instruction_type.replace('None','선택형')}
                      </Box>
                    </TableCell>
                    {/* <TableCell align="left">{row.concept_en}</TableCell> */}
                    {/* <TableCell align="left">
                      <Box sx={{width:"58px",fontSize:"14px", marginLeft:"8px", padding: "2px 6px 2px 6px", borderRadius:"4px",
                          border: (row.use_check === "F" ? "2px solid red" : (row.use_check === "T" ? "2px solid #498ad5" : (row.use_check === "C" ? "2px solid #27cc2f" : "#bbb"))), color:"#000" }}>
                        {(row.use_check === "T" ? "사용가능" : (row.use_check === "F" ? "사용불가" : (row.use_check === "C" ? "내용수정":"미분류")))}
                      </Box>
                    </TableCell> */}
                  </TableRow>
                  )):<TableRow><TableCell colSpan={3} component="th" scope="row" align="center">데이터가 없습니다.</TableCell></TableRow>}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={{marginTop:"12px"}}>
              {pagination !== undefined ? (
                  <>
                  <CustomPagination pagination={pagination} goPage={goPage} />
                  <Box display="flex">
                  <TextField size="small" id="worker" value={c_page} onChange={(e)=>setC_page(e.target.value)} 
                    sx={{width:"60px",height: "23px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}} 
                    InputProps={{
                      style: {width: "60px", height:"23px", fontSize:"12px"},
                      inputProps: { 
                        spellCheck: "false" // spellcheck를 false로 설정
                      },
                    }}
                    />
                    <Button variant="contained" sx={{marginLeft:"8px",minWidth: "58px", height:"30px", fontSize:"12px"}} onClick={()=>setPage(Number(c_page))}>
                      이동
                    </Button>
                  </Box>
                  </>
              ) : ""}
            </Box>
          </Box>
          <KhmInstructionCreatePage rowDetail={data} updateAfter={updateAfter} worker={worker} order={order} />
          
        </Box>
      </Box>
    </Box>
  );
};

export default KhmInstructionListPage;
